import React from "react";
import * as ReactDOM from "react-dom";
import { Button, Modal, Toast, ListView, Icon, NoticeBar } from "antd-mobile";
import moment from "moment";

import { post } from "../../utils/request";
import { getUrlParam, href } from "../../utils/util";
import api from "./api";
import carAudio from "./sound/car.mp3";
import successAudio from "./sound/success.mp3";
import coupon from "./img/coupon.png";
import "./index.less";

let pageIndex = 0;

function closest(el, selector) {
    const matchesSelector =
        el.matches ||
        el.webkitMatchesSelector ||
        el.mozMatchesSelector ||
        el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

class WithdrawalRecordsList extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            urlOps: {},
            data: [],
            skipCount: 0,
            pageSize: 10,
            listData: [{}, {}, {}, {}, {}],
            sharkNum: 0,
            activityCode: null,
            canWithdrawalCash: 0,
            visible: false,
            successVisible: false,
            failVisible: false,
            failText: "",
            examVisible: false,
            todayVisible: false,
            noTimeVisible: false,
            shakeCode: null,
            winResult: {},
            lossResult: {},
            questionBankCode: "",
            activityEnable: true,
            baiRiActivityEnable: true, // 百日行动活动是否有效
            baiRiCode: "", // 百日行动活动编码
            activityUserPrizeCode: "",
            activityResult: {}, //活动报名姐结果
            failureVisible: false,
        };
    }

    componentDidMount() {
        window.Countly.q.push(["track_pageview", "peaceSharkIndex"]);
        window.didLogin = this.didLogin;
        window.didShare = this.didShare;
        window.didShake = this.didShake;

        this.setTime();

        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            if (
                ops.app_stoken === "null" ||
                ops.app_stoken === "(null)" ||
                ops.app_stoken === "undefined" ||
                !ops.app_stoken
            ) {
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail("您还未登录，请登录后再操作", 999);
                return;
            }
            this.checkBaiRiActivityEnable(ops);
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    //百日行动
                    // this.selectEntryByCust();
                }
            );
        }
        clearInterval(this.timeInter);
        this.checkActivityEnable(ops);
    }

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是a:否web应该程序，没有头部与底部
        };
    };

    appShare(code) {
        const { urlOps } = this.state;
        let viewPort = this.viewPort();
        post({
            url:
                api.selectHoActivityManagementSimpleDetail +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                activityCode: code,
            },
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    const data = {
                        ...res.data,
                        shareImg: res.data.shareImg ? res.data.shareImg : "",
                    };
                    if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                        if (window.webkit) {
                            window.webkit.messageHandlers.showShare.postMessage(
                                {
                                    title: data.shareTitle,
                                    url: `${window.location.origin}${window.location.pathname}#/peaceSharkShare`,
                                    cotent: data.shareContent,
                                    img: data.shareImg,
                                }
                            );
                        }
                    } else {
                        if (window.huilian) {
                            window.huilian.showShareWeixin(
                                `${window.location.origin}${window.location.pathname}#/peaceSharkShare`,
                                data.shareTitle,
                                data.shareContent,
                                data.shareImg
                            );
                        }
                    }
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("获取分享信息失败", 1);
            }
        );
    }

    didLogin(token) {
        window.location.href(
            window.location.origin +
                "/payment/#/peaceSharkIndex?app_stoken=" +
                token
        );
    }

    componentWillMount() {
        this.init();
    }

    init() {
        pageIndex = 0;
        window.localStorage.removeItem("isPost");
        window.localStorage.removeItem("moving");
    }

    selectEntryByCust() {
        const { urlOps } = this.state;
        post({
            url:
                api.selectEntryByCust +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                activityType: "BAI_RI",
            },
        }).then((res) => {
            if (res.result == "success") {
                this.setState(
                    {
                        activityResult: res.data || {},
                    },
                    () => {}
                );
            } else {
                Toast.info(res.msg, 10);
            }
        });
    }

    insertEntry() {
        // if(!moment(new Date()).isAfter('2022-11-01 00:00:00') || !moment(new Date()).isBefore('2023-01-31 23:59:59')){
        //     Toast.info('报名时间:2022年11月1日-2023年1月31日',3);
        //     return
        // }
        const { urlOps } = this.state;
        post({
            url:
                api.insertEntry +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                activityType: "BAI_RI",
            },
        }).then((res) => {
            if (res.result == "success") {
                if (res.data.successFlag == "1") {
                    href(`/peaceActivity?app_stoken=${urlOps.app_stoken}`);
                } else {
                    // href(`/peaceActivity?app_stoken=${urlOps.app_stoken}`);
                    let failureReason = [
                        "不在报名时间内",
                        "已报名",
                        "非自营车辆",
                    ];
                    if (res.data.failureReason == "2") {
                        this.setState({
                            failureVisible: true,
                        });
                    } else {
                        Toast.info(failureReason[res.data.failureReason], 3);
                    }
                }
            } else {
                Toast.info(res.msg, 10);
            }
        });
    }

    goToBaiRi() {
        const { urlOps, baiRiActivityEnable, baiRiCode } = this.state;
        if (baiRiActivityEnable) {
            href(
                `hundredDaysActivities?app_stoken=${urlOps.app_stoken}&activityCode=${baiRiCode}`
            );
        } else {
            Toast.info("活动已结束", 2);
        }
    }

    setTime() {
        const classes = document.getElementsByClassName("shark-button");
        // let timer2 = undefined
        if (classes.length > 0) {
            if (classes[0].classList.length < 2) {
                classes[0].classList.add("actived");
            } else {
                classes[0].classList.remove("actived");
            }
            this.timer2 = setTimeout(() => {
                if (document.getElementById("shark") === null) {
                    // 跳转至其他界面需要关闭定时器
                    window.clearTimeout(this.timer2);
                    return;
                }
                this.setTime();
            }, 5000);
        } else {
            window.clearTimeout(this.timer2);
        }
    }

    didShare() {
        window.localStorage.setItem("shareType", "1");
        window.Countly.q.push([
            "add_event",
            {
                key: "weixin_share",
                segmentation: {},
            },
        ]);
        React.$hlInsight.track("weixin_share", {});
    }

    didShake() {
        window.localStorage.setItem("isShark", "1");
    }

    doShare() {
        const { urlOps } = this.state;
        let viewPort = this.viewPort();
        post({
            url:
                api.selectHoActivityManagementSimpleDetail +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                activityCode: this.state.activityCode,
            },
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    const data = {
                        ...res.data,
                    };
                    if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                        if (window.webkit) {
                            window.webkit.messageHandlers.share.postMessage({
                                title: data.shareTitle,
                                url: `${window.location.origin}${window.location.pathname}#/peaceSharkShare`,
                                cotent: data.shareContent,
                                img: data.shareImg,
                            });
                            this.dsq();
                        }
                    } else {
                        if (window.huilian) {
                            window.huilian.shareWeixin(
                                `${window.location.origin}${window.location.pathname}#/peaceSharkShare`,
                                data.shareTitle,
                                data.shareContent,
                                data.shareImg
                            );
                            this.dsq();
                        }
                    }
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("获取分享信息失败", 1);
            }
        );
    }

    dsq() {
        const shareType = window.localStorage.getItem("shareType");
        // this.timer = undefined;
        if (shareType) {
            window.clearTimeout(this.timer);
            this.finishShareTask();
        } else {
            this.timer = setTimeout(() => {
                if (document.getElementById("shark") === null) {
                    // 跳转至其他界面需要关闭定时器
                    window.clearTimeout(this.timer);
                    return;
                }
                this.dsq();
            }, 3000);
        }
    }

    listenShark() {
        const isShark = window.localStorage.getItem("isShark");
        // this.timer1 = undefined;
        if (isShark) {
            window.clearTimeout(this.timer1);
            this.doShake();
        } else {
            this.timer1 = setTimeout(() => {
                if (document.getElementById("shark") === null) {
                    // 跳转至其他界面需要关闭定时器
                    window.clearTimeout(this.timer1);
                    return;
                }
                this.listenShark();
            }, 500);
        }
    }

    finishShareTask() {
        const { urlOps, winResult } = this.state;
        post({
            url:
                api.finishShareTask +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                activityUserPrizeCode: winResult.activityUserPrizeCode,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    Toast.info("分享成功!");
                    this.getPinganCash(urlOps);
                } else {
                    Toast.info(res.msg, 1);
                }
                window.localStorage.removeItem("shareType");
            },
            (res) => {
                Toast.info("调用分享结果失败", 1);
            }
        );
    }

    getImage(code) {
        const { urlOps, activityCode } = this.state;
        post({
            url:
                api.createCourse +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {
                questionBankCode: code,
                type: "0",
                activityCode,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    this.setState({
                        lossResult: { prizeImg: res.data.courseUrl },
                    });
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("调用学习课程接口失败", 1);
            }
        );
    }

    doShake() {
        const {
            urlOps,
            todayVisible,
            noTimeVisible,
            visible,
            successVisible,
            examVisible,
            failVisible,
        } = this.state;
        const isPost = window.localStorage.getItem("isPost");
        const moving = window.localStorage.getItem("moving");
        const length =
            document.getElementsByClassName("car-left")[0].classList.length;
        if (
            visible ||
            successVisible ||
            failVisible ||
            noTimeVisible ||
            todayVisible ||
            examVisible ||
            isPost ||
            length == 2 ||
            moving
        ) {
            return;
        }
        window.localStorage.setItem("moving", 1);
        if (
            urlOps.app_stoken === "null" ||
            urlOps.app_stoken === "(null)" ||
            urlOps.app_stoken === "undefined" ||
            !urlOps.app_stoken
        ) {
            // let viewPort = this.viewPort();
            // if (
            //     viewPort.ios ||
            //     viewPort.iPhone ||
            //     viewPort.iPad
            // ) {
            //     if(window.webkit){
            //         window.webkit.messageHandlers.login.postMessage('');
            //     }
            // } else {
            //     if(window.huilian){
            //         window.huilian.login('');
            //     }
            // }
            Toast.fail("您还未登录，请登录后再操作", 999);
            return;
        }
        var button = document.getElementsByClassName("shark-button");
        var left = document.getElementsByClassName("car-left");
        var right = document.getElementsByClassName("car-right");
        button[0].classList.add("pushed");
        left[0].classList.add("animated-left");
        right[0].classList.add("animated-right");
        setTimeout(function () {
            button[0].classList.remove("pushed");
        }, 300);
        setTimeout(function () {
            left[0].classList.remove("animated-left");
            right[0].classList.remove("animated-right");
        }, 1000);
        const audio = new Audio(carAudio);
        audio.play();

        post({
            url:
                api.shakePinganActivity +
                "?app_stoken=" +
                urlOps.app_stoken +
                "&activity=365",
            data: {},
        }).then(
            (res) => {
                window.localStorage.removeItem("isShark");
                const _this = this;
                if (res.result === "success" && res.data) {
                    this.setState({ shakeCode: res.data.shakeCode });
                    if (res.data.shakeCode == 2 || res.data.shakeCode == 3) {
                        setTimeout(() => {
                            this.setState({
                                examVisible: true,
                                questionBankCode: res.data.questionBankCode,
                            });
                        }, 1000);
                        setTimeout(() => {
                            window.localStorage.removeItem("moving");
                        }, 2000);
                        window.localStorage.removeItem("isPost");
                        return;
                    } else if (res.data.shakeCode == 4) {
                        setTimeout(() => {
                            this.setState({ todayVisible: true });
                        }, 1000);
                        setTimeout(() => {
                            window.localStorage.removeItem("moving");
                        }, 2000);
                        window.localStorage.removeItem("isPost");
                        return;
                    } else if (res.data.shakeCode == 5) {
                        setTimeout(() => {
                            this.setState({ noTimeVisible: true });
                        }, 1000);
                        setTimeout(() => {
                            window.localStorage.removeItem("moving");
                        }, 2000);
                        window.localStorage.removeItem("isPost");
                        return;
                    }
                    if (res.data.shakeCode === 1) {
                        window.localStorage.removeItem("isPost");
                        setTimeout(() => {
                            this.setState({ visible: true });
                        }, 2000);
                        setTimeout(() => {
                            const loading =
                                document.getElementsByClassName(
                                    "red-pocket-loading"
                                );
                            const audio1 = new Audio(successAudio);
                            loading[0].classList.add("display");
                            audio1.play();
                        }, 3000);
                        setTimeout(() => {
                            this.setState({
                                winResult: res.data.winResult,
                                successVisible: true,
                            });
                        }, 4000);
                        setTimeout(() => {
                            window.localStorage.removeItem("moving");
                        }, 2000);
                    } else if (res.data.shakeCode == 0) {
                        window.localStorage.removeItem("isPost");
                        _this.getImage(res.data.lossResult.questionBankCode);
                        setTimeout(() => {
                            const randomIndex = Math.floor(Math.random() * 10);
                            const failText = [
                                "太可惜了，与红包擦肩而过",
                                "换个姿势再摇一次",
                                "可能是你太帅了，红包被你亮瞎了！",
                                "不是不中，时辰未到！",
                                "再次搏一搏，单车变摩托！",
                                "万水千山总是情，中个大奖肯定行！",
                                "人间自有真情在，没有红包还有爱！",
                                "床前明月光，红包在发光！",
                                "人间自有真情在，能省一块是一块！",
                                "春风不度玉门关，今天红包已发干！",
                            ][randomIndex];
                            this.setState({ failVisible: true, failText });
                        }, 1000);
                        setTimeout(() => {
                            window.localStorage.removeItem("moving");
                        }, 2000);
                    }
                    this.getSharkNum(urlOps);
                    this.getPinganCash(urlOps);
                    setTimeout(() => {
                        window.localStorage.removeItem("isPost");
                    }, 6000);
                } else {
                    Toast.info(res.msg, 10);
                }
            },
            (res) => {
                console.log("查询失败", res);
            }
        );
    }

    getSharkNum(ops) {
        post({
            url:
                api.getUserCanShakeNum +
                "?app_stoken=" +
                ops.app_stoken +
                "&activity=365",
            data: {},
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    this.appShare(res.data.activityCode);
                    this.setState({
                        sharkNum: res.data.canShakeNum,
                        activityCode: res.data.activityCode,
                    });
                    this.getList(ops);
                } else {
                    Toast.info(res.msg, 10);
                }
            },
            (res) => {
                console.log("查询失败", res);
            }
        );
    }

    getPinganCash(ops) {
        post({
            url:
                api.pinganActivityUserCash +
                "?app_stoken=" +
                ops.app_stoken +
                "&activity=365",
            data: {},
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    this.setState({
                        canWithdrawalCash: res.data.canWithdrawalCash,
                    });
                } else {
                    Toast.info(res.msg, 10);
                }
            },
            (res) => {
                console.log("查询失败", res);
            }
        );
    }

    checkBaiRiActivityEnable(ops) {
        post({
            url:
                api.baiRiActivityEnable +
                "?app_stoken=" +
                ops.app_stoken +
                "&activity=365",
            data: {},
        }).then(
            (res) => {
                if (res.result === "success") {
                    if (res.data.enable) {
                        this.setState({
                            baiRiCode: res.data.activityCode,
                            baiRiActivityEnable: true,
                        });
                    } else {
                        // Toast.fail('活动已结束', 10)
                        this.setState({ baiRiActivityEnable: false });
                    }
                } else {
                    Toast.info(res.msg, 10);
                }
            },
            (res) => {
                console.log("查询失败", res);
            }
        );
    }

    checkActivityEnable(ops) {
        post({
            url:
                api.checkPinganActivityEnable +
                "?app_stoken=" +
                ops.app_stoken +
                "&activity=365",
            data: {},
        }).then(
            (res) => {
                if (res.result === "success") {
                    if (res.data) {
                        this.getSharkNum(ops);
                        this.getPinganCash(ops);
                        this.timeInter = setInterval(() => {
                            this.listenShark();
                        }, 5000);
                    } else {
                        Toast.fail("活动已结束", 10);
                        this.setState({ activityEnable: false });
                    }
                } else {
                    Toast.info(res.msg, 10);
                }
            },
            (res) => {
                console.log("查询失败", res);
            }
        );
    }

    getList(ops) {
        const { skipCount, pageSize, listData, activityCode } = this.state;

        post({
            url:
                api.queryCourseRankList +
                "?app_stoken=" +
                ops.app_stoken +
                "&activity=365",
            data: {
                activityCode,
                pageSize: pageSize,
            },
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    if (res.data.length > 0) {
                        res.data.slice(0, 5).map((item, index) => {
                            listData[index] = item;
                        });
                        this.setState({ listData });
                    }
                } else {
                }
            },
            (res) => {
                console.log("查询列表失败", res);
            }
        );
    }

    // 绑车
    bindCar() {
        let viewPort = this.viewPort();
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                window.webkit.messageHandlers.linkCarBind.postMessage("");
            }
        } else {
            if (window.huilian) {
                window.huilian.linkCarBind();
            }
        }
    }

    // 查违章
    getViolations() {
        let viewPort = this.viewPort();
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                window.webkit.messageHandlers.violations.postMessage("");
            }
        } else {
            if (window.huilian) {
                window.huilian.violations("1");
            }
        }
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, ".am-modal-content");
        if (!pNode) {
            e.preventDefault();
        }
    };

    render() {
        const {
            data,
            urlOps,
            activityCode,
            sharkNum,
            canWithdrawalCash,
            visible,
            successVisible,
            examVisible,
            failVisible,
            failText,
            shakeCode,
            questionBankCode,
            winResult,
            lossResult,
            todayVisible,
            noTimeVisible,
            activityResult,
            failureVisible,
            activityEnable,
            baiRiActivityEnable,
        } = this.state;
        // let index = data.length - 1;
        let index = 0;
        const row = (rowData, sectionID, rowID) => {
            let obj = {};
            if (index <= data.length - 1) {
                obj = data[index++];
            } else {
                return <div></div>;
            }

            return (
                <div
                    className="item"
                    key={rowID}
                    onClick={() => {
                        href(`/withdrawalRecords?id=${obj.contentId}`);
                    }}
                >
                    <div className="left">
                        <p style={{ fontSize: "0.14rem", color: "#333333" }}>
                            {obj.contentId}
                        </p>
                        <p
                            style={{
                                fontSize: "0.12rem",
                                color: "#666666",
                                lineHeight: "0.01rem",
                            }}
                        >
                            {obj.gmtCreate}
                        </p>
                    </div>
                    <div className="right">
                        <Icon type="right" />
                    </div>
                </div>
            );
        };

        const listRow = () => {
            const { listData } = this.state;
            const newDiv = listData.map((item, index) => {
                return (
                    <div
                        key={index}
                        className="list-item"
                    >
                        <span
                            className={["logo", `logo${index + 1}`].join(" ")}
                        ></span>
                        <span
                            style={{
                                marginRight: "0.15rem",
                                width: "1.04rem",
                                display: "inline-block",
                                textAlign: "center",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {item.customerName ? item.customerName : "-"}
                        </span>
                        <span
                            style={{
                                width: "0.6rem",
                                display: "inline-block",
                                textAlign: "center",
                            }}
                        >
                            {item.courseTimes ? item.courseTimes : "-"}课次
                        </span>
                    </div>
                );
            });
            return newDiv;
        };

        return (
            <div
                className="index_bg"
                id="shark"
            >
                <NoticeBar
                    mode="closable"
                    marqueeProps={{ loop: true }}
                    style={{ position: "relative" }}
                >
                    通知：平安365将于5月23日正式下线，届时将无法支持提现，请于下线前及时安排！请知悉！
                </NoticeBar>
                <div className="main-bg">
                    <div className="top-logo">
                        <div className="top-logo-left"></div>
                        <div className="top-logo-right"></div>
                    </div>
                    <div className="amount-content">
                        <div className="money-logo"></div>
                        <div className="money-content">
                            <p style={{ color: "#676767" }}>平安金</p>
                            <p
                                style={{
                                    fontWeight: "600",
                                    fontSize: "0.17rem",
                                    width: "0.7rem",
                                }}
                            >
                                {canWithdrawalCash}
                            </p>
                        </div>
                        <div className="divider" />
                        <div
                            className="word-content"
                            onClick={() => {
                                if (!activityEnable) {
                                    Toast.info("活动已结束", 2);
                                    return;
                                }
                                href(
                                    `/withdrawal?app_stoken=${urlOps.app_stoken}&activityCode=${this.state.activityCode}`
                                );
                            }}
                        >
                            <span>提现</span>
                            <Icon
                                type="right"
                                style={{
                                    marginTop: "-0.01rem",
                                    color: "#9A9A9A",
                                }}
                            ></Icon>
                        </div>
                    </div>
                    <div className="car-left"></div>
                    <div className="car-right"></div>
                    <div className="decorate-left"></div>
                    <div className="decorate-right"></div>
                </div>
                <div className="button-content">
                    <div
                        className="shark-button"
                        onClick={() => {
                            if (!activityEnable) {
                                Toast.info("活动已结束", 2);
                                return;
                            }
                            this.doShake();
                        }}
                    >
                        {/* <audio autoPlay id='audioPlay' src='./car.mp3' type="audio/mp3"></audio> */}
                    </div>
                    <div
                        style={{
                            width: "100%",
                            margin: "-0.2rem auto 0.12rem",
                            fontSize: "0.12rem",
                            color: "#fff",
                            textAlign: "center",
                        }}
                    >
                        今天可摇次数：{sharkNum} 次
                    </div>
                </div>
                <div
                    style={{
                        position: "fixed",
                        right: 0,
                        top: "4.56rem",
                        zIndex: 20,
                        color: "#fff",
                        fontSize: "0.12rem",
                    }}
                >
                    <div
                        className="record"
                        onClick={() => {
                            href(
                                `peaceSharkRecord?app_stoken=${urlOps.app_stoken}`
                            );
                        }}
                    >
                        <span
                            style={{
                                width: "0.26rem",
                                alginItems: "center",
                                marginTop: "0.05rem",
                                marginLeft: "0.15rem",
                            }}
                        >
                            中奖记录
                        </span>
                    </div>
                    <div
                        className="record"
                        onClick={() => {
                            href(
                                `safetyTrainingCoursesRecord?app_stoken=${urlOps.app_stoken}&activityCode=${activityCode}`
                            );
                        }}
                    >
                        <span
                            style={{
                                width: "0.26rem",
                                alginItems: "center",
                                marginTop: "0.05rem",
                                marginLeft: "0.15rem",
                            }}
                        >
                            学习记录
                        </span>
                    </div>
                </div>
                {/* <div className='charts-content'>
                    <div style={{ width: '100%', height: '0.07rem' }}></div>
                    <div className='content-title'></div>
                    <div className='list-title'>
                        <span style={{ marginRight: '0.78rem' }}>排名</span>
                        <span style={{ marginRight: '0.55rem' }}>账号</span>
                        <span>学习课次</span>
                    </div>
                    {listRow()}
                    <div className='list-bottom' onClick={()=>{href(`peaceSharkRank?app_stoken=${urlOps.app_stoken}&activityCode=${activityCode}`)}}>
                        <span>查看更多</span>
                    </div>
                    <div style={{ width: '100%', height: '0.15rem' }}></div>
                </div> */}

                {/* 慧联司机专属福利 */}
                {/*  */}
                {/* <div className='activity'>
                    <div className='activity-box'>
                        <div className='top-box'>
                            <div className='top-bg'></div>
                        </div>
                        {
                            
                            ( moment(new Date()).isBefore('2023-01-31 23:59:59') ?activityResult.hoEntryId ?<div className='button-success'></div>:<div className='button-over'></div>:<div className='button-up' onClick={()=>{this.goToBaiRi()}}></div>)
                        }
                        {
                             ( moment(new Date()).isBefore('2023-01-31 23:59:59') ?activityResult.hoEntryId ?<div className='success'>报名成功，于2023年2月1日正式抽奖</div>:<div className='success'>很遗憾，报名时间已结束</div>:<div className='success'>仅限已报名且符合抽奖资格的用户</div>)
                        }
                        
                        <div className='bottom'></div>
                    </div>
                </div> */}

                <div
                    className="activity"
                    style={{ paddingTop: "0.01rem" }}
                >
                    <div className="activity-box">
                        <div className="activity-logo">
                            <div className="activity-logo-left"></div>
                            <div className="activity-logo-title">活动说明</div>
                            <div className="activity-logo-right"></div>
                        </div>
                        <div className="content">
                            <p>
                                1、一期活动时间：2022年11月1日-2023年1月31日，排行榜话费奖励及百日挑战抽奖均属一期奖励；二期活动时间：2023年2月1日-2023年5月23日。
                            </p>
                            <p>
                                2、自活动开始之日起，每天都可摇一摇领取平安金激励，并且每人每天最多有3次摇红包机会哦。
                            </p>
                            <p>
                                3、摇一摇获得的平安金奖励到账需完成一定的挑战任务，如简短的安全视频学习、车辆绑车、邀好友参与等。于“中奖记录”中可查看到账情况及补充完成任务。
                            </p>
                            <p>
                                4、一旦发生违章或出险记录，则必须完成安全通关考试，否则无法继续参与摇奖。
                            </p>
                            <p>
                                5、用户获得的平安金奖励，可直接提现到充电账户或现金账户。其中提现到充电账户的额度比直接提现到个人账户将多10%额度上浮，提现到银行卡需满5元方可提现。
                            </p>
                            <p>
                                6、以上所有“慧联车辆司机”，皆指远程慧联在租车辆当前被授权/绑车司机。所有慧联车辆司机须提前完成慧联车辆关联，方法一：被运营商在APP内完成车辆授权；方法二：点击“我的-我的绑定车辆”，可进行慧联车辆的自主绑定。
                            </p>
                            <p>
                                7、同一手机号、同一账号、同一设备，满足任一条件均视为同一用户。针对非正常手段刷单抽奖的，主办方有权追究其法律责任及追回相关损失。
                            </p>
                            <p>
                                8、为保证正常参与活动，请将“远程慧联”APP升级至最新版本。
                            </p>
                            <p>
                                9、本次活动最终解释权归主办方所有，与苹果（Apple
                                Inc）无关。
                            </p>
                        </div>
                    </div>
                </div>
                <Modal
                    className="modal-activity"
                    animationType="slide-up"
                    transparent
                    popup
                    maskClosable={false}
                    visible={visible}
                    onClose={() => this.setState({ visible: false })}
                >
                    <div className="red-pocket"></div>
                    <div className="red-pocket-loading"></div>
                </Modal>
                <Modal
                    className="prize-bg"
                    transparent
                    popup
                    maskClosable={false}
                    visible={successVisible}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                    <div className="prize-content">
                        <div className="prize-title"></div>
                        <div className="content-title">
                            {winResult.prizeName}
                        </div>
                        {winResult.prizeClassify == 1 ? (
                            <div className="content-num">
                                <span
                                    style={{
                                        fontSize: "0.35rem",
                                        fontFamily: "PingFangSC-Medium",
                                    }}
                                >
                                    {winResult.cash}{" "}
                                </span>
                                <span>元</span>
                            </div>
                        ) : (
                            <div className="content-img">
                                <div
                                    style={{
                                        width: "0.72rem",
                                        height: "0.64rem",
                                        backgroundImage: `url(${
                                            winResult.prizeImg
                                                ? winResult.prizeImg
                                                : coupon
                                        })`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "0.72rem 0.64rem",
                                    }}
                                ></div>
                            </div>
                        )}
                        <div style={{ fontSize: "0.12rem" }}>
                            {winResult.prizeContent}
                        </div>
                        {winResult.taskType == 0 ? (
                            ""
                        ) : winResult.taskType == 1 ? (
                            <Button
                                className="prize-button"
                                style={{ marginLeft: "0.5rem" }}
                                onClick={() => {
                                    clearInterval(this.timeInter);
                                    // window.location.replace(window.location.pathname+`#/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${winResult.questionBankCode}&activityUserPrizeCode=${winResult.activityUserPrizeCode}&activityCode=${activityCode}`)
                                    href(
                                        `/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${winResult.questionBankCode}&activityUserPrizeCode=${winResult.activityUserPrizeCode}&activityCode=${activityCode}`
                                    );
                                }}
                            >
                                观看安全课程领取
                            </Button>
                        ) : winResult.taskType == 2 ? (
                            <Button
                                className="prize-button"
                                style={{ marginLeft: "0.5rem" }}
                                onClick={() => {
                                    clearInterval(this.timeInter);
                                    this.doShare();
                                }}
                            >
                                完成分享领取
                            </Button>
                        ) : winResult.taskType == 3 ? (
                            <Button
                                className="prize-button"
                                style={{ marginLeft: "0.5rem" }}
                                onClick={() => this.bindCar()}
                            >
                                完成绑车任务领取
                            </Button>
                        ) : (
                            ""
                        )}
                        <span
                            style={{
                                fontSize: "0.12rem",
                                color: "#fff",
                                position: "absolute",
                                width: "100%",
                                top: "2.6rem",
                                left: "0rem",
                            }}
                        >
                            *温馨提示：完成任务后奖励才可以到账哦
                        </span>
                        <div
                            style={{
                                width: "0.5rem",
                                height: "0.5rem",
                                margin: "0 auto",
                            }}
                            onClick={() => {
                                this.setState({
                                    visible: false,
                                    successVisible: false,
                                });
                            }}
                        >
                            <Icon
                                type="cross-circle"
                                style={{
                                    color: "#fff",
                                    display: "block",
                                    width: "0.22rem",
                                    height: "0.22rem",
                                    position: "absolute",
                                    left: "1.2rem",
                                    top: "3.15rem",
                                }}
                            ></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="prize-bg"
                    transparent
                    maskClosable={false}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    visible={examVisible}
                >
                    <div className="prize-content">
                        <div
                            style={{
                                fontSize: "0.18rem",
                                color: "rgba(51, 51, 51, 1)",
                                textAlign: "center",
                                marginTop: "0.32rem",
                            }}
                        >
                            考试通知
                        </div>
                        <div
                            style={{
                                fontSize: "0.14rem",
                                color: "rgba(102, 102, 102, 1)",
                                overflowWrap: "break-word",
                                textAlign: "left",
                                lineHeight: "0.2rem",
                                margin: "0.24rem 0.17rem 0.24rem 0.27rem",
                            }}
                        >
                            很遗憾，发现您最近有产生违章/出险记录，需要完成安全考试，方可继续参与哦！
                        </div>
                        <Button
                            className="prize-button"
                            style={{ marginLeft: "0.5rem" }}
                            onClick={() => {
                                clearInterval(this.timeInter);
                                href(
                                    `/safetyTrainingExam?app_stoken=${urlOps.app_stoken}&shakeCode=${shakeCode}&questionBankCode=${questionBankCode}&activityCode=${activityCode}`
                                );
                            }}
                        >
                            参加考试恢复参与资格
                        </Button>
                        <div
                            style={{
                                color: "rgba(0, 159, 144, 1)",
                                fontSize: "0.14rem",
                                marginTop: "-0.05rem",
                            }}
                            onClick={() => this.getViolations()}
                        >
                            查看相关违章记录
                        </div>
                        <div
                            style={{
                                width: "0.5rem",
                                height: "0.5rem",
                                margin: "0 auto",
                            }}
                            onClick={() => {
                                this.setState({ examVisible: false });
                            }}
                        >
                            <Icon
                                type="cross-circle"
                                style={{
                                    color: "#fff",
                                    display: "block",
                                    margin: "0.5rem auto",
                                    width: "0.22rem",
                                    height: "0.22rem",
                                    lineHeight: "0.22rem",
                                }}
                            ></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="prize-bg"
                    transparent
                    popup
                    maskClosable={false}
                    visible={failVisible}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                    <div className="prize-content">
                        <div className="fail-title"></div>
                        <div className="content-title">{failText}</div>
                        <div
                            style={{
                                fontSize: "0.12rem",
                                marginTop: "0.24rem",
                            }}
                        >
                            安全知识小提醒
                        </div>
                        <div
                            style={{
                                width: "2.06rem",
                                height: "1.16rem",
                                margin: "0.08rem auto",
                            }}
                        >
                            <div
                                style={{
                                    width: "2.06rem",
                                    height: "1.16rem",
                                    backgroundImage: `url(${lossResult.prizeImg})`,
                                    backgroundSize: "2.06rem 1.16rem",
                                    backgroundRepeat: "no-repeat",
                                }}
                            ></div>
                        </div>
                        <div
                            style={{
                                width: "0.5rem",
                                height: "0.5rem",
                                margin: "0 auto",
                            }}
                            onClick={() => {
                                this.setState({ failVisible: false });
                            }}
                        >
                            <Icon
                                type="cross-circle"
                                style={{
                                    color: "#fff",
                                    display: "block",
                                    margin: "0.5rem auto",
                                    width: "0.22rem",
                                    height: "0.22rem",
                                    lineHeight: "0.22rem",
                                }}
                            ></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="prize-bg"
                    transparent
                    maskClosable={false}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    visible={todayVisible}
                >
                    <div className="notime-content">
                        <div
                            style={{
                                fontSize: "0.2rem",
                                color: "rgba(51, 51, 51, 1)",
                                textAlign: "center",
                                marginTop: "0.42rem",
                            }}
                        >
                            今日次数已用完，请明日再来哦
                        </div>
                        <Button
                            className="prize-button"
                            style={{ marginTop: "0.3rem" }}
                            onClick={() => {
                                this.setState({ todayVisible: false });
                            }}
                        >
                            我知道了
                        </Button>
                        <div
                            style={{
                                width: "0.5rem",
                                height: "0.5rem",
                                margin: "0 auto",
                            }}
                            onClick={() => {
                                this.setState({ todayVisible: false });
                            }}
                        >
                            <Icon
                                type="cross-circle"
                                style={{
                                    color: "#fff",
                                    display: "block",
                                    margin: "0.5rem auto",
                                    width: "0.22rem",
                                    height: "0.22rem",
                                }}
                            ></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="prize-bg"
                    transparent
                    maskClosable={false}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    visible={noTimeVisible}
                >
                    <div className="notime-content">
                        <div
                            style={{
                                fontSize: "0.2rem",
                                color: "rgba(51, 51, 51, 1)",
                                textAlign: "center",
                                marginTop: "0.42rem",
                            }}
                        >
                            您本次活动的可摇次数已达上限
                        </div>
                        <Button
                            className="prize-button"
                            style={{ marginTop: "0.3rem" }}
                            onClick={() => {
                                this.setState({ noTimeVisible: false });
                            }}
                        >
                            我知道了
                        </Button>
                        <div
                            style={{
                                width: "0.5rem",
                                height: "0.5rem",
                                margin: "0 auto",
                            }}
                            onClick={() => {
                                this.setState({ noTimeVisible: false });
                            }}
                        >
                            <Icon
                                type="cross-circle"
                                style={{
                                    color: "#fff",
                                    display: "block",
                                    margin: "0.5rem auto",
                                    width: "0.22rem",
                                    height: "0.22rem",
                                    lineHeight: "0.22rem",
                                }}
                            ></Icon>
                        </div>
                    </div>
                </Modal>

                {/* 百日行动 */}
                <Modal
                    className="prize-bg"
                    transparent
                    popup
                    maskClosable={false}
                    visible={failureVisible}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                    <div
                        className="prize-content"
                        style={{ height: "2.1rem" }}
                    >
                        <div className="fail-title"></div>
                        <div
                            className="content-title"
                            style={{
                                margin: "0.5rem 0.2rem 0.3rem",
                                fontSize: "0.14rem",
                            }}
                        >
                            本次活动仅慧联车辆司机可参与本次大奖瓜分，请确认是否完成车辆授权或自主绑定慧联车辆。
                        </div>
                        <Button
                            className="prize-button"
                            onClick={() => this.bindCar()}
                        >
                            去绑车
                        </Button>
                        <Icon
                            type="cross-circle"
                            style={{
                                color: "#fff",
                                display: "block",
                                margin: "0.4rem auto",
                            }}
                            onClick={() => {
                                this.setState({ failureVisible: false });
                            }}
                        ></Icon>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default WithdrawalRecordsList;



// WEBPACK FOOTER //
// ./src/peaceSharkIndex/index/index.js